<script setup lang="ts">
import { NEWS_TYPE_ENUM, type Notizia } from "@gasparigit/omnia-sdk";

defineProps<{
  content: Notizia;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentCardsBaseContent v-bind="$props" :content="content" :info-label="NEWS_TYPE_ENUM[content.news_type]" :show-abstract="true">
    <template #center>
      <img
        loading="lazy"
        v-if="(content.news_type === 'videonota' && content.video_thumb_url) || content.image?.original_url"
        :src="content.image?.original_url || content.video_thumb_url || undefined"
        :srcset="content.image?.srcset || undefined"
        :alt="content.title"
        class="object-cover"
      />
    </template>
  </FrontContentCardsBaseContent>
</template>
